module.exports = __webpack_public_path__ + "static/media/node mongodb.ff576afd.pdf";